<app-template-text
  (onblur)="onblur.emit()"
  [counter]="counter"
  [disabled]="disabled"
  [characters]="characters"
  [value]="value"
  [minlength]="minlength"
  [maxlength]="maxlength"
  [control]="control"
  [label]="label"
/>
